import React         from 'react';
import { Redirect }  from 'react-router-dom';
import Course        from './Course';
import CourseList    from './CourseList';
import CourseBuilder from './builderComponents/CourseBuilder';

export const CourseConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    routes  : [
        {
            path      : '/course/:view_type/:course_id',
            component : Course,
            permission: { component_name: 'course', permission_type: 'view_type' },
        },
        {
            path      : '/course/list',
            component : CourseList,
            permission: { component_name: 'course', permission_type: 'list' },
        },
        {
            path      : '/course/:view_type/',
            component : Course,
            permission: { component_name: 'course', permission_type: 'view_type' },
        },
        {
            path      : '/builder/course',
            component : CourseBuilder,
            permission: { component_name: 'course', permission_type: 'create' },
        },
        {
            path      : '/course',
            component : () => <Redirect to="/course/list" />,
            permission: { component_name: 'course', permission_type: 'list' },
        },
    ]
};



// WEBPACK FOOTER //
// src/main/content/course/CourseConfig.js